import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { IndexBookingVoucherResponseSchema } from "../response/IndexBookingVoucherResponse";

const API_VERSION = "v3";

interface GetAllBookingProps {
    voucher_number?: string | null;
}

const useGetAllBooking = (query: GetAllBookingProps) => {
    const cleanQueryKey = (query: GetAllBookingProps) => [
        "booking-vouchers",
        query.voucher_number ? `voucher:${query.voucher_number}` : "",
    ].filter(Boolean);

    return useQuery({
        queryKey: cleanQueryKey(query),
        queryFn: async () => {
            try {
                const params = {
                    voucher_number: query.voucher_number || "",
                };

                const response = await privateApi.get(`/${API_VERSION}/booking-voucher`, { params });

                // Validasi response
                const validationResult = IndexBookingVoucherResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Bookings data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Bookings`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
        enabled: !!query.voucher_number, // Only run the query if voucher_number is provided
    });
};

export default useGetAllBooking;